import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import { useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import useCustomState from "../../hooks/State";
import { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Call from "../../service/API";
import { ERROR_COLOR, ORANGE_COLOR } from "../../utils/const";
import { cities } from "../../utils/const";
import { UpdateProjectsList } from "../../store/actions";
import { useDispatch } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const EditUserModal = (props) => {
  const handleClose = () => {
    props.open.handleChange(false);
  };

  const userName = useCustomState("");
  const userLastName = useCustomState("");
  const userPhoneNumber = useCustomState("");
  const userDescription = useCustomState("");

  const userNameError = useCustomState({ error: false, text: "" });
  const userLastNameError = useCustomState({ error: false, text: "" });
  const userPhoneNumberError = useCustomState({ error: false, text: "" });

  const userNameChanged = (e) => {
    userNameError.handleChange({ error: false, text: "" });
    userName.handleChange(e.target.value);
  };

  const userLastNameChanged = (e) => {
    userLastNameError.handleChange({ error: false, text: "" });
    userLastName.handleChange(e.target.value);
  };

  const userPhoneNumberChanged = (e) => {
    userPhoneNumberError.handleChange({ error: false, text: "" });
    userPhoneNumber.handleChange(e.target.value);
  };

  const userDescriptionChanged = (e) => {
    userDescription.handleChange(e.target.value);
  };

  useEffect(() => {
    console.log(props.user);
    userName.handleChange(props.user.user_name);
    userLastName.handleChange(props.user.user_lastname);
    userPhoneNumber.handleChange(props.user.user_phone);
    const description = props.user?.other_information?.description
      ? props.user.other_information.description
      : "وارد نشده";
    userDescription.handleChange(description);
  }, []);

  const editUser = (e) => {
    let hasError = false;
    const name = userName.value;
    const lastname = userLastName.value;
    const phoneNumber = userPhoneNumber.value;
    const description = userDescription.value;

    if (name.length == 0) {
      userNameError.handleChange({
        error: true,
        text: "واردکردن نام کاربر الزامی است.",
      });
      hasError = true;
    }
    if (lastname.length == 0) {
      userLastNameError.handleChange({
        error: true,
        text: "واردکردن نام خانوادگی کاربر الزامی است.",
      });
      hasError = true;
    }
    if (phoneNumber.length == 0) {
      userPhoneNumberError.handleChange({
        error: true,
        text: "واردکردن شماره تلفن کاربر الزامی است.",
      });
      hasError = true;
    }
    // check phoneNumber Format
    if (phoneNumber.length != 11 || isNaN(phoneNumber)) {
      userPhoneNumberError.handleChange({
        error: true,
        text: "فرمت شماره تلفن وارد شده صحیح نمی باشد.",
      });
      hasError = true;
    }

    if (hasError) {
      return;
    }

    const info = {
      other_user_id: props.user.user_id,
      user_name: name,
      user_lastname: lastname,
      user_password: "1234",
      user_sms_code: "1234",
      user_profile: {},
      user_phone: phoneNumber,
      other_information: {
        description: description,
      },
    };
    const data = new FormData();
    data.append("data", JSON.stringify(info));

    Call("POST", "users/admin/changeUserProfile", data)
      .then((response) => {
        if (response.data.code == 200) {
          handleClose();
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          const status = error.response.status;
          // console.log(data);
          if (status == 500 || status == 403) {
            userPhoneNumberError.handleChange({
              error: true,
              text: "شماره تلفن وارد شده متعلق به کاربر دیگری است.",
            });
          }
        }
      });
  };

  const marginStyle = {
    marginBottom: "16px",
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open.value}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={props.open.value}>
        <Box sx={style} style={{ borderRadius: "8px" }}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
            ویرایش اطلاعات کاربر
          </Typography>
          <Grid
            style={{ marginTop: "24px" }}
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <Grid style={marginStyle} item xs={12} sm={12} md={12} lg={12}>
              <TextField
                onChange={userNameChanged}
                value={userName.value}
                error={userNameError.value.error}
                helperText={userNameError.value.text}
                label="نام کاربر"
                variant="standard"
                fullWidth
              />
            </Grid>
            <Grid style={marginStyle} item xs={12} sm={12} md={12} lg={12}>
              <TextField
                onChange={userLastNameChanged}
                value={userLastName.value}
                error={userLastNameError.value.error}
                helperText={userLastNameError.value.text}
                label="نام خانوادگی کاربر"
                variant="standard"
                fullWidth
              />
            </Grid>
            <Grid style={marginStyle} item xs={12} sm={12} md={12} lg={12}>
              <TextField
                onChange={userPhoneNumberChanged}
                value={userPhoneNumber.value}
                error={userPhoneNumberError.value.error}
                helperText={userPhoneNumberError.value.text}
                label="شماره تلفن"
                variant="standard"
                fullWidth
              />
            </Grid>

            <Grid style={marginStyle} item xs={12} sm={12} md={12} lg={12}>
              <TextField
                onChange={userDescriptionChanged}
                value={userDescription.value}
                multiline
                rows={8}
                maxRows={12}
                label="توضیحات کاربر"
                variant="filled"
                fullWidth
              />
            </Grid>

            <Grid
              style={{ marginTop: "48px" }}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Button
                onClick={editUser}
                style={{ color: "#fff", backgroundColor: ORANGE_COLOR }}
                variant="contained"
              >
                ویرایش
              </Button>
              <Button
                onClick={handleClose}
                style={{
                  color: "#fff",
                  marginRight: "4px",
                  backgroundColor: ERROR_COLOR,
                }}
                variant="contained"
              >
                انصراف
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EditUserModal;
